/** @format */

let defaultPhotoURL = "/static/avatar_default.jpg";

export default defaultPhotoURL;
